import type { FontSettings } from '@/@core/models/api/configResponse';

/**
 * Applies custom font settings while respecting user browser font size preferences.
 * Uses CSS max() function to automatically take the larger of browser default (1rem)
 * and custom font size, ensuring accessibility is maintained.
 *
 * Examples:
 * - Browser: 24px, Custom: 18px → Result: 24px (browser wins)
 * - Browser: 16px, Custom: 20px → Result: 20px (custom wins)
 * - Browser: 16px, Custom: 16px → Result: 16px (same value)
 */
export async function applyCustomFontSettings(fontSettings: FontSettings) {
  if (fontSettings) {
    document.documentElement.style.setProperty(
      '--custom-font-family',
      fontSettings.family ?? 'Raleway'
    );

    if (fontSettings.size) {
      document.documentElement.style.setProperty(
        '--custom-font-size',
        `max(1rem, ${fontSettings.size}px)`
      );
    } else {
      // Fallback: respect browser default or use 16px minimum
      document.documentElement.style.setProperty('--custom-font-size', 'max(1rem, 16px)');
    }
  }
}
